module.exports = __webpack_public_path__ + "img/syukyaku-syukyaku-002.50971b6e.jpg";